module.exports = __webpack_public_path__ + "img/favicon-reverse.7532a8d2.svg";